import {
  isLauraCanada,
  validateEmail,
  validatePhoneNumber,
} from '../utils/helpers';

export default (element) => {
  const pauseTickerBtn = element.querySelector('[data-target="pause-ticker"]');
  const pauseTickerIcon = element.querySelector(
    '[data-target="pause-ticker-icon"]',
  );
  const playTickerBtn = element.querySelector(
    '[data-target="play-ticker-icon"]',
  );
  const tickerScrollingItems = element.querySelectorAll('.animate-scroll');
  const smsSignupInput = element.querySelector('[data-sms-signup-input]');
  const emailSignupInput = element.querySelector('[data-email-signup-input]');
  const emailSignupForm = element.querySelector('#emailSignup');
  const phoneSignupForm = element.querySelector('#phoneSignup');

  const pauseTicker = () => {
    tickerScrollingItems.forEach((el) => {
      el.classList.toggle('pause');
    });
    if (pauseTickerIcon) pauseTickerIcon.classList.toggle('hidden');
    if (playTickerBtn) playTickerBtn.classList.toggle('hidden');
  };

  const init = () => {
    pauseTickerBtn?.addEventListener('click', pauseTicker);
    element
      .querySelectorAll('[data-action="store-locator"]')
      .forEach((el) =>
        el.addEventListener('click', () =>
          document.dispatchEvent(new CustomEvent('openStoreLocator')),
        ),
      );
  };

  init();

  const addMask = (e) => {
    const x = e.target.value
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = `${x[1] ? `(${x[1]}) ` : ''}${x[2]}${
      x[3] ? `-${x[3]}` : ''
    }`;
  };

  const initNewsletterForm = () => {
    const newsletterForm = element.querySelector('[data-newsletter-form]');
    const emailSignupButton = element.querySelector('[data-email-signup]');
    const smsSignupButton = element.querySelector('[data-sms-signup]');
    

    newsletterForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
   
    emailSignupInput?.addEventListener('input', (e) => {
      const emailData = e.target.value;
      if (!emailData || !validateEmail(emailData)) {
        if(!emailSignupForm.classList.contains('hideBtn')) {
          emailSignupForm.classList.add("hideBtn");
        }
      } else if(emailSignupForm.classList.contains('hideBtn')) {
          emailSignupForm.classList.remove("hideBtn");
      }
    });


    smsSignupInput?.addEventListener('input', (e) => {
      const phoneValue = e.target.value.replace(/\D/g, '');
      const isValid = phoneValue ? validatePhoneNumber(phoneValue) : false;
      if (!isValid) {
        if(!phoneSignupForm.classList.contains('hideBtn')) {
          phoneSignupForm.classList.add("hideBtn");
        }
      } else if(phoneSignupForm.classList.contains('hideBtn')) {
          phoneSignupForm.classList.remove("hideBtn");
      }
    });

    emailSignupButton?.addEventListener('click', async () => {
      handleSubmit('email', newsletterForm);
    });

    emailSignupInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        handleSubmit('email', newsletterForm);
      }
    });

    smsSignupButton?.addEventListener('click', async () => {
      handleSubmit('sms', newsletterForm);
    });

    smsSignupInput?.addEventListener('input', (e) => {
      if (
        e.inputType !== 'deleteContentBackward' &&
        e.inputType !== 'deleteContentForward'
      ) {
        addMask(e);
      }
    });

    smsSignupInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        handleSubmit('sms', newsletterForm);
      }
    });
  };

  const handleSubmit = async (input, newsletterForm) => {
    let inputValue;
    let consentId = {};
    let consentValue = {};
    const eventProperties = {
      action: 'accept',
      valid_until: 'unlimited',
    };

    const btn = newsletterForm.querySelector(`[data-${input}-signup]`);
    const inputFeedback = element.querySelector(
      `[data-newsletter-feedback-${input}]`,
    );

    inputFeedback.classList.remove('active');
    inputFeedback.textContent = '';
    inputFeedback.classList.remove('text-error');
    const inputField = newsletterForm.querySelector(`[name="footer-${input}"]`);
    if (input === 'email') {
      if (!inputField.value || !validateEmail(inputField.value)) {
        inputFeedback.textContent = window.TMW.Strings.newsletter.invalidEmail;
        inputFeedback.classList.add('active');
        inputFeedback.classList.add('text-error');
        return;
      }
      inputValue = inputField.value.toLowerCase().trim();
      consentId = {
        email_id: inputValue,
      };
      consentValue = {
        email: inputValue,
      };
      eventProperties.category = isLauraCanada() ? 'lau_email' : 'ml_email';
      eventProperties.email = inputValue;
    } else if (input === 'sms') {
      inputValue = inputField.value.replace(/\D/g, '');
      const isValid = inputValue ? validatePhoneNumber(inputValue) : false;
      if (!isValid) {
        inputFeedback.textContent = window.TMW.Strings.newsletter.invalidPhone;
        inputFeedback.classList.add('active');
        inputFeedback.classList.add('text-error');
        return;
      }
      consentId = {
        phone_id: `${inputValue}`,
      };
      consentValue = {
        phone: `${inputValue}`,
      };
      eventProperties.category = isLauraCanada() ? 'lau_sms' : 'ml_sms';
      eventProperties.phone = `${inputValue}`;
    }
    btn.disabled = true;

    // eslint-disable-next-line no-undef
    exponea.identify(
      consentId,
      consentValue,
      // eslint-disable-next-line prefer-arrow-callback, func-names
      function () {
        // successCallback
        // eslint-disable-next-line no-undef
        exponea.track('consent', eventProperties);

        inputField.value = '';
        inputFeedback.textContent =
          window.TMW.Strings.newsletter.successMessage;
        inputFeedback.classList.add('active');
        inputFeedback.classList.add('text-misc-green');
        btn.disabled = false;

        smsSignupInput?.removeEventListener('input', addMask);
        inputField.blur();
        if (input === 'email') {
          emailSignupForm.classList.add("hideBtn");
        }

        if (input === 'sms') {
          phoneSignupForm.classList.add("hideBtn");
        }
      },

      // eslint-disable-next-line prefer-arrow-callback, func-names
      function () {
        // errorrCallback
      },
      true,
    );
  };

  initNewsletterForm();
};
